let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a3BEG")).then(() => parcelRequire('7nySO'));